export enum AmlTaskEnum {
  CANCEL_PROCESS = 'CANCEL PROCESS AMLID',
  CREATE_DOSSIER = 'CREATE DOSSIER AMLID',
  START_PROCESS = 'START PROCESS AMLID',
  ONESHOT_REGISTER = 'ONESHOT REGISTER AMLID',
  RESEND_OTP = 'SEND OTP AMLID',
  SIGN = 'ISSUE AND SIGN AMLID',
  CONFIRM_SIGNED = 'CONFIRM SIGNED',
  STIPULATE = 'STIPULATE',
  SIGN_OR_SEND = 'SIGN OR SEND',
}

export enum AmlSseEventEnum {
  OK = 'AMLID_EVENT_TYPE_OK',
  KO = 'AMLID_EVENT_TYPE_KO',
  WARNING = 'AMLID_EVENT_TYPE_WARNING',
}
